<nav class="navbar navbar-light bg-light" *ngIf="user">
    <div class="container-fluid">
        <a class="navbar-brand" routerLink="/private/logs" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
            <img src="assets/images/Logo-MEDS-2023.svg" class="img-fluid" width="260px" />
        </a>
        <div class="d-flex" >
            <button class="btn btn-outline-secondary" (click)="logout()"><i class="bi bi-box-arrow-right fs-3"></i> Salir</button>
        </div>
    </div>
</nav>